
import { Vue, Component, Prop } from 'vue-property-decorator';
import RouteNames from '@/entities/RouteNames';
import UIButton from '@/components/button/ui-button.vue';
import PlusIcon from '@/components/icons/PlusIcon.vue';

@Component({
	components: {
		UIButton,
		PlusIcon,
	},
})
export default class InvoiceHeader extends Vue {
	@Prop({ required: true }) readonly title!: string;
	@Prop({ default: null }) readonly lastUpdated!: string | null;
	@Prop({ default: null }) readonly buttonText!: string | null;
	@Prop({ default: () => {} }) readonly buttonAction!: () => void;
	createNewInvoice() {
		this.$router.push({ name: RouteNames.INVOICE_SUBMIT });
	}
}
